/* eslint-disable @typescript-eslint/no-explicit-any */
import { RaceTable } from 'features/Race/components'
import { nonNftTableCoinColumns } from 'utils/columns'
import { useAppDispatch, useAppSelector, useUpdateEffect } from 'hooks'
import React, { memo, useEffect, useMemo, useState } from 'react'
import { GetRaceListParams } from 'models'
import { NUMBER, STRING } from 'apps/constants'
import { NOTIFICATION_MESSAGE } from 'i18n/constants'
import { useTranslation } from 'react-i18next'
import { notification } from 'antd'
import { useSelector } from 'react-redux'
import { errorNonNftListTable, getNonNftListTable } from 'apps/redux/userCreateRace/selector'
import { getNonNftList } from 'apps/redux/userCreateRace/action'

const defaultParams: GetRaceListParams = {
  limit: NUMBER.FORTY,
  page: NUMBER.ONE
}

function TableNonNft(props: { filters: { filterTypeNonNft: string } }) {
  const {
    filters: { filterTypeNonNft }
  } = props
  const [api, contextHolder] = notification.useNotification()
  const { t } = useTranslation()
  const { profile } = useAppSelector(state => state)
  const [dataTable, setDataTable] = useState<any>([])
  const [params, setParams] = useState<GetRaceListParams>(defaultParams)
  const [loading, setLoading] = useState<boolean>(false)
  const [total, setTotal] = useState()
  const dispatch = useAppDispatch()
  const dataNonNftTable = useSelector(getNonNftListTable)
  const errorNonNft = useSelector(errorNonNftListTable)

  const memoizedResultListSelectionColumns = useMemo(() => {
    return nonNftTableCoinColumns
  }, [profile])

  useEffect(() => {
    setParams({
      ...params,
      page: 1,
      boostType: ['All', 'Type'].includes(filterTypeNonNft) ? '' : filterTypeNonNft
    })
  }, [filterTypeNonNft])

  useEffect(() => {
    if (profile.guild_id !== NUMBER.ZERO) {
      setLoading(true)
      getListDataTable()
    }
  }, [params, profile.guild_id])

  useEffect(() => {
    if (errorNonNft) {
      openNotification(STRING.ERROR, errorNonNft)
    }
  }, [errorNonNft])

  useEffect(() => {
    if (dataNonNftTable?.records) {
      setLoading(false)
      const formatData = dataNonNftTable?.records.map((record: any) => {
        return {
          ...record,
          coin_type: record.type,
          item_name: record.name,
          avatar: record.img
        }
      })
      setDataTable(params.page > NUMBER.ONE ? [...dataTable, ...formatData] : formatData)
      setTotal(dataNonNftTable?.total || NUMBER.ZERO)
    }
  }, [dataNonNftTable])

  const openNotification = (message: string, description: string) => {
    notification.config({
      duration: NUMBER.FOUR
    })

    api.info({
      message,
      description,
      placement: 'bottomRight',
      className: message === STRING.ERROR ? 'ant-custom-error' : 'ant-custom-success'
    })
  }

  const getListDataTable = async () => {
    dispatch(getNonNftList({ guildId: profile.guild_id, params }))
  }

  useUpdateEffect(() => {
    setParams({ ...params, page: NUMBER.ONE })
  }, [])

  return (
    <div>
      {contextHolder}
      <RaceTable
        columns={memoizedResultListSelectionColumns}
        data={dataTable}
        raisePage={setParams}
        loader={!loading}
        params={params}
        checkLoadingPage={false}
        totalRace={total}
        currentUser={profile}
        noDataText={t(`${NOTIFICATION_MESSAGE}.dataNotFound`)}
        isShowVipIcon={true}
      />
    </div>
  )
}

export default memo(TableNonNft)
